import { AfterViewInit, Component } from '@angular/core';
import { SvgIconComponent } from '../../../services/svg-service/svg-icon/svg-icon';
import { TRANSLATIONS_IMPORTS } from '../../../shared/shared-exports/translation.exports';
import { RouterLink } from '@angular/router';
import { AnimationService } from '../../../services/animation.service';

interface AccordionItem {
  title: string;
  content: string;
  isOpen: boolean;
}

import { MATERIAL_IMPORTS } from '../../../shared/shared-exports/material.exports';

@Component({
  selector: 'app-system-features',
  imports: [RouterLink, ...TRANSLATIONS_IMPORTS, ...MATERIAL_IMPORTS],
  templateUrl: './system-features.html',
  styleUrl: './system-features.scss',
})
export class SystemFeatures implements AfterViewInit {
  constructor(private animation: AnimationService) {}

  ngAfterViewInit() {
    this.animation.scrollAnimate('.feature-section');
  }

  acordionItems: AccordionItem[] = [
    {
      title: 'Monitoring',
      content: `Monitoring in MEL (Monitoring, Evaluation, and Learning) involves the continuous and systematic collection of data on program activities,
      outputs, and outcomes to track progress against planned targets. It helps identify implementation gaps, risks, and emerging challenges early, enabling
      timely corrective actions. Through regular tracking and reporting, monitoring ensures transparency, accountability, and effective use of resources,
      while supporting managers and stakeholders to make informed, evidence-based decisions throughout the project lifecycle.`,
      isOpen: true,
    },
    {
      title: 'Evaluation',
      content: `Evaluation in MEL (Monitoring, Evaluation, and Learning) is the systematic assessment of a project or program's effectiveness, impact, and value at specific points or after
      completion, focusing on how well it achieved its goals, identifying successes, failures, and unintended  outcomes to inform future decisions and ensure accountability, differing
      from ongoing monitoring by providing deeper insights into why things happened and driving adaptive management.`,
      isOpen: false,
    },
    {
      title: 'Learning',
      content: `Learning in MEL focuses on systematically capturing insights generated from monitoring and evaluation activities to strengthen future interventions. It involves
      deliberate reflection on what worked, what did not work, and the underlying reasons behind those outcomes. Through this process, organizations build institutional knowledge,
      encourage evidence-based decision-making, and promote adaptive strategies that respond to changing contexts. Learning ensures that experiences are not lost but are actively
      used to refine program design, improve implementation approaches, and enhance overall effectiveness and impact over time.`,
      isOpen: false,
    },
  ];

  toggle(index: number) {
    this.acordionItems.forEach((item, i) => {
      item.isOpen = i === index;
    });
  }
}
